import React from 'react';
import moment from 'moment';
import 'moment/locale/de';
import Draggable from 'react-draggable';
import {_GPY,__GPYPost} from '../../../env.js'
import WaitCube from '../../../WaitCube.js'
import $ from "jquery";

class LineUp extends React.Component {

	constructor(props) {
			super(props);
			var w = 800;
			this.state = {
						gamesIsLoaded: false,
						games : {},
						currentGame :{id:-1},
						gameUnsave: false,
	 				  playersHomeIsLoaded: false,
						playersHome: {},
						playersGuestIsLoaded: false,
						playersGuest: {},
						width:w,
						height:Math.floor(w/1.7777777778),
						unsave : false,
						saving: false,
			};
	}

	componentDidMount() {
		this.getGames();
	}

	preparePlayer(p) {
		if(p.vsUiState === undefined || p.vsUiState === '') {
				p.vsUiState = '{"player":false, "substitue":false, "score": 0 , "pos": {"x": 10, "y": 10, "xp":5, "yp": 10}, "sortIndex" : 0 }';
		}
		p._config = JSON.parse(p.vsUiState);
		p._config.shadow = false;
		p._config.pos.x = this.toXPos(parseFloat(p._config.pos.xp));
		p._config.pos.y = this.toYPos(parseFloat(p._config.pos.yp));
	}

	getPlayers() {
		__GPYPost('getPlayers',{},(res) => {
			var players = this.mergePlayers(res,'GAME_PLAYER');
			this.setState({
						playersHomeIsLoaded: true,
						playersHome: players,
			});
		})
	}


  mergePlayers(res,role){
		var players = [];
		var ids = {};

		if( this.state.currentGame!==undefined && this.state.currentGame.players!==undefined ){
				this.state.currentGame.players.Player.forEach((p) => {
				if(p.vsRole === role) {
					this.preparePlayer(p);
					players.push(p);
					ids["_"+p.id] = p.id;
				}
		 });
	}

	res.Players.Player.forEach((p) => {
				this.preparePlayer(p);
				if(!( ("_"+p.id) in ids)) {
					players.push(p)
				}
	 });

	 players.sort(function (playerA, playerB) {
		 var a = playerA.lastName;
		 var b = playerB.lastName;
		 if (a === b) {
			 return 0;
	 		}
	 		if (typeof a === typeof b) {
			 return a < b ? -1 : 1;
	 		}
			return typeof a < typeof b ? -1 : 1;
		});

	 return players;
  }




	storeAll() {

		this.setState({saving:true});

		var playersHome = JSON.parse(JSON.stringify(this.state.playersHome));

		playersHome.forEach((p) => {
					p._config.pos.xp = this.toXPercent(p._config.pos.x);
					p._config.pos.yp = this.toYPercent(p._config.pos.y);
					delete p._config.shadow;
					p.vsUiState = JSON.stringify(p._config);
					console.log("player",p);
					if(p._config.player) {
						p.vsRole = "GAME_PLAYER";
					} else {
						p.vsRole = '';
					}
					delete p._config
		});

		var obj = {};
		obj.gameId = this.state.currentGame.id;
		obj.players = playersHome.filter(p => p.vsRole !== '');
		obj.team = [];

		__GPYPost('storeGameLineUp',obj,(res)=> {
				this.setState({saving:false,unsave:false});
		});

  }



	getGames(obj) {
		if(obj === undefined) {
			obj = {};
		}
		__GPYPost('getGames',obj,(res)=>{
			this.setState({
				gamesIsLoaded: true,
				games: res,
			});

			if(_GPY.uiStates.selectedGamePk !== undefined) {
				this.onSelectGame( _GPY.uiStates.selectedGamePk );
			} else {
				$('#gametype_SoccerFootball_scoreboard_lineup').collapse('show');
			}
		});
	}




	onSelectGame(e) {
		var pk = parseInt (e);


		var g = undefined;
		this.state.games.Games.Game.forEach((t) => {
				if(t.id === pk) {
					g = t;
				}
		});

		if(g===undefined) {
				this.state.games.Games.GuestGame.forEach((t) => {
					if(t.id === pk) {
						g = t;
					}
				});
		}
		console.log("currentGame",g);

		if(g!== undefined) {
			this.setState({playersHome:[],currentGame: g, gameUnsave: false});
			$('#gametype_SoccerFootball_scoreboard_lineup').collapse('hide');
			__GPYPost('setUIState',{selectedGamePk: g.id});
		}

	  this.getPlayers();
	}



	togglePlayer(t){
		console.log(t);
		  if(t._config.player) {
				t._config.player = false;
				t._config.substitue = true;
			} else if(t._config.substitue) {
				t._config.player = false;
				t._config.substitue = false;
			} else {
				t._config.player = true;
				t._config.substitue = false;
			}
			this.setState({unsave:true});
	}



	onControlledDragStop(player, e, position) {
		 if(player !== undefined) {
			 player._config.pos.x = position.x;
			 player._config.pos.y = position.y;
			 player._config.shadow = false;
		 }
		 this.setState({unsave:true});

  }


	onStart(player) {
		if(player !== undefined) {
			player._config.shadow = true;
			this.forceUpdate();
		}
	}



	toXPos(fkValue) {
		return Math.round((fkValue / 100) * this.state.width);
	}
	toXPercent(fkValue) {
		return ((fkValue * 100.0) / this.state.width);
	}
	toYPos(fkValue) {
		return Math.round((fkValue / 100) * this.state.height);
	}
	toYPercent(fkValue) {
		return ((fkValue * 100.0) / this.state.height);
	}
	toScaleValue(fkValue){
		 var p = 100 / 2160 * this.props.height;
		 return Math.floor(fkValue * p / 100);
	}


  up(ar,item) {
		  var idx = -1;
			for(var i=0; i<ar.length; i++){
				if(ar[i] === item) {
					idx = i;
				}
			}

			if(idx > 0 && idx < ar.length) {
				ar.splice((idx-1),0,ar.splice(idx,1)[0]);
			}

			for(var c=0; c<ar.length; c++){
					ar[c]._config.sortIndex = c;
			}
			this.setState({unsave:true});
	}

	down(ar,item) {
		var idx = -1;
		for(var i=0; i<ar.length; i++){
			if(ar[i] === item) {
				idx = i;
			}
		}

		if(idx >= 0 && idx < ar.length) {
			ar.splice((idx+1),0,ar.splice(idx,1)[0]);
		}
		for(var o=0; o<ar.length; o++){
				ar[o]._config.sortIndex = o;
		}
		this.setState({unsave:true});
	}



	render(){
		var countHomePlayer = this.state.playersHomeIsLoaded ?this.state.playersHome.filter(p => p._config.player).length:0;

		var sortPlayers = (list) => {
						 list.sort( function(a, b) {
							 					 if(a._config===undefined||b._config===undefined){
							 						 return (""+a.lastName).localeCompare(b.lastName);
							 					 };

							 					 if(a._config.player!==undefined && b._config.player!==undefined) {
							 						if(a._config.player && !b._config.player) {
							 							return 0;
							 						} else if(!a._config.player && b._config.player) {
							 							 return 1;
							 						}
							 					 }

							 					 if(a._config.sortIndex!==undefined && a._config.score!=="" && b._config.score!==undefined && b._config.score!=="" && a._config.score!== b._config.score) {
							 						 return b._config.score - a._config.score;
							 					 }
							 					return (""+a.lastName).localeCompare(b.lastName);

							 }
						 );
						 return list;
		}

		var playersHome = [];
		if(this.state.playersHomeIsLoaded) {
			playersHome = sortPlayers(this.state.playersHome);
		}

		return (
		<div>

			<div className="row justify-content-end">
				<div className="col-6 text-right"><button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#gametype_SoccerFootball_scoreboard_lineup" aria-expanded="false" aria-controls="gametype_SoccerFootball_scoreboard_lineup">
				<span className="text-secondary"><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"></span>&nbsp;
				{this.state.currentGame.id > 0 ? this.state.currentGame.gameName + " - " + moment(this.state.currentGame.startTime).locale('de').format('L') + " (" + moment(this.state.currentGame.startTime).locale(_GPY.locale).format('HH:mm') + "-"+  moment(this.state.currentGame.endTime).locale(_GPY.locale).format('HH:mm')+ ")":_GPY.i18n.get('gametype_SoccerFootball_scoreboard_select_game_title')}
				&nbsp;<span className="glyphicon glyphicon-chevron-down" aria-hidden="true"></span></span>
				</button></div>

			</div>
			<div className="collapse bg-light" id="gametype_SoccerFootball_scoreboard_lineup">
				<div className="row justify-content-center pt-4">
						{this.state.gamesIsLoaded && this.state.games.Games.Game.length>0?
							<div className="col-12 text-center"><h3>{_GPY.i18n.get('gametype_SoccerFootball_scoreboard_select_game_title')}</h3></div>
						:
							<div className="col-12 text-center"><h3>{_GPY.i18n.get('gametype_SoccerFootball_scoreboard_select_nogame_title')}</h3></div>
						}
						<div className="col-12 col-sm-12 col-md-8 col-xl-8">
							<div className="list-group">
								 {this.state.gamesIsLoaded ? this.state.games.Games.Game.map((t) => {

									 if( (_GPY.toLocaleMoment(t.endTime) + (1000*60*60)) > _GPY.toLocaleMoment(moment()) )  {

										return (
										<button key={t.id} onClick={this.onSelectGame.bind(this,t.id)} className={t.id === this.state.currentGame.id?"list-group-item list-group-item-action list-group-item-success flex-column align-items-start pointer":"list-group-item list-group-item-action flex-column align-items-start pointer"}>
											<div className="row p-2">
											<div className="col-12 text-center"><span>{t.gameName} - {moment(t.startTime).locale('de').format('L')}  ({moment(t.startTime).locale(_GPY.locale).format('HH:mm')} - {moment(t.endTime).locale(_GPY.locale).format('HH:mm')})</span></div>
											</div>
										</button>);
									} else {
											return "";
									}

								 })  : "" }
							</div>
						</div>
				</div>
				<div className="row p-4">
					<div className="col border-top"></div>
					<div className="col-1 text-center text-muted"><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/></div>
					<div className="col border-top"></div>
				</div>
		</div>


{this.state.currentGame.id > 0 ?


					 <div className="row">

				 <div className="col mt-3">
						<h3>Drivers</h3>

						<div className="row">
								<div className="col">
										<span className="text-muted">Selected Drivers : {countHomePlayer}</span>
								</div>
								 <div className="col">
								<button type="button" className={this.state.unsave?(this.state.saving?"btn btn-primary mt-2 disabled":"btn btn-primary mt-2"):"btn btn-light mt-2 disabled"} onClick={this.storeAll.bind(this)}>{this.state.saving?<span className="glyphicon glyphicon-refresh"/>:<span className="glyphicon glyphicon-save"/>}&nbsp;Store</button>
								</div>
						</div>

						<div className="list-group pt-3">
{/* onClick={ this.togglePlayer.bind(this,t)}  */}
						{this.state.playersHomeIsLoaded ? playersHome.map((t) =>
							<div key={"home"+t.id} className={t._config.player?"list-group-item flex-column list-group-item-success align-items-start":t._config.substitue?"list-group-item flex-column list-group-item-warning align-items-start":"list-group-item flex-column align-items-start"}>
								 <div className="row" >
								 			<div className="col-2 col-md-2">
												<img style={{maxWidth : '25px',maxHeight : '25px'}} src={t.profileImage!==undefined&&t.profileImage!==""?_GPY.resource("upload/" + t.profileImage):_GPY.resource("images/default_avatar.jpg")} className="img-fluid" alt="X"/>
											</div>
											<div className="col-4 col-md-4">
												<small>{t.numOrPos!==undefined&&t.numOrPos!==""?t.numOrPos+" ":""}{t.fistName} {t.lastName}{t.role!=='' && t.role!==undefined?' ('+t.role+')':''}</small>
											</div>

											{ t.role!=='coach' ? t._config.player || t._config.substitue?

												<div className="col-12 col-md-6">
												<div className="row p-0">
													<div className="col-2 col-md-2">
															<button className={t._config.player?"btn btn-sm btn-success mr-1":"btn btn-sm btn-light mr-1"} onClick={ ()=>{    if(t._config.substitue){t._config.player=true;t._config.substitue=false;} else {t._config.player=false ;t._config.substitue=false;};this.setState({unsave:true});}}><span className="glyphicon glyphicon-user" aria-hidden="true"></span></button>
													</div>
													<div className="col-10 col-md-10">
															<form><input value={t._config.score} className="form-control" placeholder="score" type="text" onChange={(e)=>{t._config.score = _GPY.toNumber(e.target.value);	this.setState({unsave:true});}}/></form>
													</div>
												</div>
											 </div>
													:
												<div className="col-12 col-md-6">
														<button className={t._config.player?"btn btn-sm btn-success mr-1":"btn btn-sm btn-light mr-1"} onClick={ ()=>{t._config.player=true;t._config.substitue=false;this.setState({unsave:true});}}><span className="glyphicon glyphicon-user" aria-hidden="true"></span></button>
												</div>
										 : "" }
								 </div>
							</div>
						) :  <WaitCube/>  }

						</div>
				 </div>




{/** DRAG FIELD **/}


				</div>

:""}

		</div>
		)
	}

}
export default LineUp;
